import React, {useEffect, useState} from "react";
import {Button, InputNumber, Popover, Space, Typography} from "antd";
import "./PageJumper.css";

const {Text} = Typography;

/**
 * Salto diretto a una pagina: avvolge l'indicatore "Pag. X / N" (children) in un popover
 * con un campo numerico, cosi' non serve cliccare le frecce N volte per arrivare in fondo.
 * Invio o "Vai" confermano; il valore viene sempre vincolato a [1..total].
 */
export default function PageJumper({current, total, onGo, children, placement = "bottom", disabled = false})
{
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState(current + 1);

	// Riallinea il campo alla pagina corrente ad ogni apertura (e se la pagina cambia da fuori).
	useEffect(() =>
	{
		if (!open) setValue(current + 1);
	}, [current, open]);

	const go = () =>
	{
		const n = Number(value);
		if (!Number.isFinite(n)) return;
		const index = Math.min(total, Math.max(1, Math.round(n))) - 1;
		setOpen(false);
		onGo(index);
	};

	if (disabled || !total)
		return children;

	return (
		<Popover
			open={open}
			onOpenChange={setOpen}
			trigger="click"
			placement={placement}
			content={(
				<Space size={6}>
					<Text type="secondary" style={{fontSize: 12}}>Vai a pagina</Text>
					<InputNumber
						autoFocus
						size="small"
						min={1}
						max={total}
						value={value}
						onChange={setValue}
						onPressEnter={go}
						style={{width: 72}}
					/>
					<Text type="secondary" style={{fontSize: 12}}>/ {total}</Text>
					<Button size="small" type="primary" onClick={go}>Vai</Button>
				</Space>
			)}
		>
			<span className="page-jumper-trigger" title="Vai a una pagina specifica">{children}</span>
		</Popover>
	);
}
